/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React from 'react';
import { CContainer, CHeader, CHeaderBrand, CHeaderNav, CNavItem } from '@coreui/react';
import AppHeaderDropdown from './header/AppHeaderDropdown';

const AppHeader = (props) => {
  return (
    <CHeader style={{ border: 'none', background: 'rgb(0 0 0 / 20%)' }} className="headerWrapper">
      <CContainer fluid>
        <CHeaderBrand className="mx-auto d-md-none" to="/"></CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem>
            <img src="images/logo1.svg" alt="Autire" height={37} />
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav>
          <CNavItem></CNavItem>
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          <AppHeaderDropdown {...props} />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default AppHeader;
